import { useMemo } from "react";

import { defineMessages, IntlShape } from "react-intl";

import { GeoStatus } from "@mapmycustomers/shared/types/base/Located";

const messages = defineMessages<string>({
  [GeoStatus.ADDRESS_AND_CITY_MISSING]: {
    id: "preview.location.geocodeInfo.addressAndCityMissing",
    defaultMessage:
      "Address invalid as both the street address and city are missing. Please update the address below or manually drop the pin on the map.",
    description: "Preview entity pane - geocode info - address And City Missing",
  },
  [GeoStatus.GEOCODING_ERROR]: {
    id: "preview.location.geocodeInfo.geocodingError",
    defaultMessage:
      "We’re experiencing problems with our mapping provider and are unable to map this record. Please check back tomorrow. ",
    description: "Preview entity pane - geocode info - Geocoding Error",
  },
  [GeoStatus.GEOCODING_TIMEOUT]: {
    id: "preview.location.geocodeInfo.geocodingTimeout",
    defaultMessage:
      "We’re experiencing problems with our mapping provider and are unable to map this record. Please check back tomorrow. ",
    description: "Preview entity pane - geocode info - Geocoding Timeout",
  },
  [GeoStatus.MAX_GEOCODES_REACHED]: {
    id: "preview.location.geocodeInfo.maxGeocodesReached",
    defaultMessage:
      "We’re experiencing heavy geocoding usage and are unable to map this record. Please check back tomorrow. ",
    description: "Preview entity pane - geocode info - max Geocodes Reached",
  },
  [GeoStatus.NO_PROVIDER]: {
    id: "preview.location.geocodeInfo.noProvider",
    defaultMessage:
      "We’re experiencing problems with our mapping provider and are unable to map this record. Please check back tomorrow. ",
    description: "Preview entity pane - geocode info - no Provider",
  },
  [GeoStatus.ORG_GEOCODE_LIMIT_REACHED]: {
    id: "preview.location.geocodeInfo.orgGeocodeLimitReached",
    defaultMessage:
      "Your organization has reached its daily limit of geocodes (placement of pins on the map). We have automatically queued this record for geocoding once available. Please check back tomorrow.",
    description: "Preview entity pane - geocode info - org Geocode Limit Reached",
  },
  [GeoStatus.ZERO_RESULTS]: {
    id: "preview.location.geocodeInfo.zeroResults",
    defaultMessage:
      "Address invalid. Please update the address below or manually drop the pin on the map.",
    description: "Preview entity pane - geocode info - zero results",
  },
});

const useGeocodeInfo = (intl: IntlShape, status: GeoStatus | null): string | undefined =>
  useMemo(() => {
    if (status && messages[status]) {
      return intl.formatMessage(messages[status]);
    }
    return undefined;
  }, [intl, status]);

export default useGeocodeInfo;
